import React from 'react';

const Services = () => {
  return (
    <div className="page-content">
      <div className="page-header">
        <h1>Services</h1>
      </div>
      <div className="page-text">
        <div className="service-item">
          <p>DeadAir.ai is not a product. It is access to a capability few will ever touch-the ability to shape discourse at scale, invisibly and with precision. Our network operates in the shadows where conversations are born, narratives crystallize, and public sentiment tilts. Those who partner with us don't react to the world—they help steer it.</p>
          <p>Influence is never cheap. Packages begin at <b>$125,000 per month</b>, reflecting the infrastructure, expertise, and discretion required to operate at this level. This threshold ensures only those who recognize both the stakes and the leverage step forward.</p>
          <p>Every engagement is protected by defense-grade encryption, zero-trust architecture, and multi-layered anonymity protocols. Client identity and strategic intent remain undiscoverable, even under the most determined scrutiny. To work with DeadAir.ai is to step behind the veil—to gain access to a tool of uncommon reach and quiet power.</p>
          <p>Heard, but unseen...everywhere.<br/>Unparalleled influence without exposure: DeadAir.ai</p>
        </div>
      </div>
    </div>
  );
};

export default Services;